import { FieldControllerProps } from '@dreryk/react-common';
import { Checkbox, ClassNameProp } from '@dreryk/react-components';

import { AddGrantingDateFieldLabel } from './AddGrantingDateFieldLabel';

type AddGrantingDateFieldProps = FieldControllerProps<'grantingDateFieldEnabled', boolean> & ClassNameProp;

export const AddGrantingDateField = (props: AddGrantingDateFieldProps): JSX.Element => {
   const controller = props.register(props.name);

   return (
      <Checkbox
         testId={props.name}
         label={<AddGrantingDateFieldLabel />}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
